import { createFileRoute } from '@tanstack/react-router'
import { PaymentsSettingsPage } from '@/features/admin/payments'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/payments/')({
  component: PaymentsSettingsPage,
  beforeLoad: requireRole(['admin']),
})
